import * as ACTION from '../constants';

const INITIAL_STATE = {
  error: null,
  loading: false,
  data: {},
};

export default function (state = INITIAL_STATE, action) {
  window.emitter && window.emitter.emit(action.type, action);
  switch (action.type) {
    case ACTION.SYSTEMUSER_TOUCH_REQUEST:
      return {
        ...state,
        data: {},
        loading: true,
        error: null,
      };
    case ACTION.SYSTEMUSER_TOUCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data || {},
        error: null,
      };
    case ACTION.SYSTEMUSER_TOUCH_FAILURE:
      return {
        ...state,
        data: {},
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
